export const base_url=process.env.NODE_ENV==='production' ? "" : 'http://localhost:3000/';


export const GetStartedImages={
  complete_webtalk_account : {
      url:`${base_url}images/complete-webtalk-account.svg`
    
  },
  link_a_payment_account : {
      url:`${base_url}images/link-a-payment-account.svg`
    
  },
  login_daily_and_be_social : {
      url:`${base_url}images/login-daily-and-be-social.svg`
    
  },
}